/**
 * @author wuTao
 * @description 单店报告
 * @Date 2023/05/30
 */
import React from 'react';
import {connect} from 'dva';
import {reduxTemplateCofig, templateConfig} from './config'

import {framework_tool} from '@/tool';

let {WizContainer, WizReduxTemplate} = framework_tool;

class StoreReportList extends WizContainer {

  componentName = 'StoreReportList';

  constructor(props) {
    super(props);
    this.state = {}
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _downloadFile = (e) => {
    if (e.record) {
      let record = e.record;
      let {fileId,importName} = record;
      if (fileId){
        let url = getOssFilePath(fileId)
        this.getBlob(url, (blob) => {
          this.saveAs(blob, importName+'.xlsx');
        });
      }
    }
  }


  /**
   * 获取 blob
   *   {String} url 目标文件地址
   *  {cb} 下载完的保存回调
   */
  getBlob(url, cb) {
    let xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.responseType = 'blob';
    xhr.onload = function () {
      if (xhr.status === 200) {
        cb(xhr.response);
      }
    };
    xhr.send();
  }

  /**
   * 保存
   *   {Blob} blob
   *   {String} filename 想要保存的文件名称
   */
  saveAs(blob, filename) {
    if (window.navigator.msSaveOrOpenBlob) {
      navigator.msSaveBlob(blob, filename);
    } else {
      let link = document.createElement('a');
      let body = document.querySelector('body');
      link.href = window.URL.createObjectURL(blob);
      link.download = filename;
      // fix Firefox
      link.style.display = 'none';
      body.appendChild(link);
      link.click();
      body.removeChild(link);
      window.URL.revokeObjectURL(link.href);
    };
  }

  _render() {
    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig:templateConfig({
        _this: this,
        _downloadFile: this._downloadFile
      }),
      apiDataFormat: {},
    })
    return <WizReduxTemplate {..._reduxTemplateCofig} />
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(StoreReportList);
